import React from 'react'
import { Chart } from "react-google-charts";
import { shadeDefault } from '../InsightsColors';

const InsightBarGraphView =(props)=>{
    const {viewData, activeOption} = props

    const currentOption = activeOption;// || viewData.DefaultOption;
    
    //console.log("layout response view", viewData.ViewData);

    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData)
        return (
            <Chart
                chartType="BarChart"
                data={viewData.ViewData[currentOption].ChartData}
                options={{
                    title: "",
                    bars: "vertical", // Required for Material Bar Charts.
                    bar: { groupWidth: "90%" },
                    hAxis: { title: viewData.ViewData[currentOption].Y_AXIS_Title },
                    // vAxis: { title: viewData.X_AXIS_Title },
                    legend: "none",
                    vAxis: {
                        title: viewData.X_AXIS_Title,
                        format: 'decimal', // You can customize the format as needed
                        viewWindow: {
                          min: 0, // Adjust as needed based on your data
                        },
                    },
                    animation: {
                        duration: 1000,
                        easing: "out",
                    },
                    colors: shadeDefault
                }}
                width="100%"
                height="100%"
            />
        )

    return null;
}

export default InsightBarGraphView
